import { render, staticRenderFns } from "./RecommendCollection.vue?vue&type=template&id=054b219a&"
import script from "./RecommendCollection.vue?vue&type=script&lang=js&"
export * from "./RecommendCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('054b219a')) {
      api.createRecord('054b219a', component.options)
    } else {
      api.reload('054b219a', component.options)
    }
    module.hot.accept("./RecommendCollection.vue?vue&type=template&id=054b219a&", function () {
      api.rerender('054b219a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/home/RecommendCollection.vue"
export default component.exports